"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isRefundPayment = exports.hasLoyaltyPointProductDiscounts = exports.hasLoyaltyTierProductDiscounts = exports.hasLoyaltyPointCartDiscounts = exports.hasLoyaltyTierCartDiscounts = exports.showLoyaltyPointDiscountIcon = exports.showLoyaltyTierDiscountIcon = exports.isTierOrPointLoyaltyDiscount = exports.getLoyaltyData = void 0;
const products_1 = require("@getgreenline/products");
const lodash_1 = require("lodash");
const loyaltyLogApi_1 = require("../api/loyaltyLogApi");
const loyaltyLogsUtils_1 = require("./loyaltyLogsUtils");
const hasLoyaltyPermission = (permissions) => !!permissions && permissions.canAccessLoyalty;
const shouldCheckLoyaltyLogs = (permissions, payment, featureToggleFlags, showLoyalty) => {
    return hasLoyaltyPermission(permissions) &&
        payment.customerId !== null &&
        featureToggleFlags.canUseCustomReceipt
        ? showLoyalty !== null && showLoyalty !== void 0 ? showLoyalty : true // If the receipt settings are not defined, default to true
        : featureToggleFlags.canDisplayLoyaltyInfoOnReceipt;
};
const isCustomerLoyaltyTierMatched = (customer, discount) => {
    const customerLoyaltyTier = (customer === null || customer === void 0 ? void 0 : customer.loyaltyTierId) || null;
    if (discount.loyaltyTiers && discount.loyaltyTiers.length > 0) {
        return discount.loyaltyTiers.some((tier) => tier.id === customerLoyaltyTier);
    }
    const isLoyaltyTierMatched = discount.loyaltyTierId !== null && discount.loyaltyTierId === customerLoyaltyTier;
    return isLoyaltyTierMatched;
};
const getLoyaltyData = (permissions, payment, featureToggleFlags, showLoyalty, logger) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b, _c;
    const checkLoyaltyLogs = shouldCheckLoyaltyLogs(permissions, payment, featureToggleFlags, showLoyalty);
    if (!checkLoyaltyLogs) {
        return;
    }
    const loyaltyLogs = yield (0, loyaltyLogApi_1.getLoyaltyLogs)(payment.companyId, {
        paymentId: payment.id,
    });
    logger && logger('Loyalty logs', { loyaltyLogs });
    const mappedDiscountIdToAmount = (0, loyaltyLogsUtils_1.mapDiscountIdToAmount)(loyaltyLogs);
    const loyaltyEarned = (_a = loyaltyLogs.find((log) => log.amount > 0)) === null || _a === void 0 ? void 0 : _a.amount;
    const loyaltyBalance = !(0, lodash_1.isNil)((_b = loyaltyLogs[0]) === null || _b === void 0 ? void 0 : _b.newAmount)
        ? loyaltyLogs[0].newAmount
        : undefined;
    // If the payment is a refund, we need to check if the loyalty points are reversed that were earned from the original sale
    const loyaltyReversed = (_c = loyaltyLogs.find((log) => payment.refundPaymentId && log.discountId === null && log.amount < 0)) === null || _c === void 0 ? void 0 : _c.amount;
    const loyaltyData = {
        mappedDiscountIdToAmount,
        loyaltyBalance,
        loyaltyEarned,
        loyaltyReversed,
    };
    logger && logger('loyalty Data', { loyaltyData });
    return loyaltyData;
});
exports.getLoyaltyData = getLoyaltyData;
const isTierOrPointLoyaltyDiscount = (applyType, discount) => {
    if (!discount.isLoyalty) {
        return undefined;
    }
    const isLoyaltyDiscount = discount.applyType === applyType;
    if (!isLoyaltyDiscount) {
        return undefined;
    }
    const loyaltyCost = discount.loyaltyCost || 0;
    return loyaltyCost === 0
        ? products_1.DiscountModels.LoyaltyDiscountType.LOYALTY_TIER
        : products_1.DiscountModels.LoyaltyDiscountType.LOYALTY_POINT;
};
exports.isTierOrPointLoyaltyDiscount = isTierOrPointLoyaltyDiscount;
const showLoyaltyTierDiscountIcon = ({ permissions, customer, discount, }) => {
    if (!hasLoyaltyPermission(permissions) || !customer) {
        return false;
    }
    const customerLoyaltyTier = customer.loyaltyTierId;
    if (discount.loyaltyTiers && discount.loyaltyTiers.length > 0) {
        const isLoyaltyTierMatched = discount.loyaltyTiers.some((tier) => tier.id === customerLoyaltyTier);
        return isLoyaltyTierMatched && discount.loyaltyCost === 0;
    }
    const isLoyaltyTierMatched = discount.loyaltyTierId !== null && discount.loyaltyTierId === customerLoyaltyTier;
    return isLoyaltyTierMatched && discount.loyaltyCost === 0;
};
exports.showLoyaltyTierDiscountIcon = showLoyaltyTierDiscountIcon;
const showLoyaltyPointDiscountIcon = ({ permissions, discount, }) => hasLoyaltyPermission(permissions) && discount.loyaltyCost > 0;
exports.showLoyaltyPointDiscountIcon = showLoyaltyPointDiscountIcon;
const hasLoyaltyTierCartDiscounts = ({ permissions, payment, }) => {
    const cartDiscounts = payment.availableCartDiscounts;
    if (!hasLoyaltyPermission(permissions) || cartDiscounts.length === 0) {
        return false;
    }
    const matchingDiscount = cartDiscounts.filter((discount) => {
        return (isCustomerLoyaltyTierMatched(payment.customer, discount) &&
            (0, exports.isTierOrPointLoyaltyDiscount)('cart', discount) ===
                products_1.DiscountModels.LoyaltyDiscountType.LOYALTY_TIER);
    });
    return matchingDiscount.length > 0;
};
exports.hasLoyaltyTierCartDiscounts = hasLoyaltyTierCartDiscounts;
const hasLoyaltyPointCartDiscounts = ({ permissions, payment, }) => {
    const cartDiscounts = payment.availableCartDiscounts;
    if (!hasLoyaltyPermission(permissions) || cartDiscounts.length === 0) {
        return false;
    }
    const matchingDiscount = cartDiscounts.filter((discount) => (0, exports.isTierOrPointLoyaltyDiscount)('cart', discount) ===
        products_1.DiscountModels.LoyaltyDiscountType.LOYALTY_POINT);
    return matchingDiscount.length > 0;
};
exports.hasLoyaltyPointCartDiscounts = hasLoyaltyPointCartDiscounts;
const hasLoyaltyTierProductDiscounts = ({ permissions, customer, paymentLine, }) => {
    const productDiscounts = paymentLine.availableLineDiscounts;
    const loyaltyDiscounts = productDiscounts.filter((discount) => discount.isLoyalty);
    if (!hasLoyaltyPermission(permissions) || loyaltyDiscounts.length === 0) {
        return false;
    }
    const matchingDiscount = loyaltyDiscounts.filter((discount) => {
        return (isCustomerLoyaltyTierMatched(customer, discount) &&
            (0, exports.isTierOrPointLoyaltyDiscount)('products', discount) ===
                products_1.DiscountModels.LoyaltyDiscountType.LOYALTY_TIER);
    });
    return matchingDiscount.length > 0;
};
exports.hasLoyaltyTierProductDiscounts = hasLoyaltyTierProductDiscounts;
const hasLoyaltyPointProductDiscounts = ({ permissions, paymentLine, }) => {
    const productDiscounts = paymentLine.availableLineDiscounts;
    if (!hasLoyaltyPermission(permissions) || productDiscounts.length === 0) {
        return false;
    }
    const matchingDiscount = productDiscounts.filter((discount) => (0, exports.isTierOrPointLoyaltyDiscount)('products', discount) ===
        products_1.DiscountModels.LoyaltyDiscountType.LOYALTY_POINT);
    return matchingDiscount.length > 0;
};
exports.hasLoyaltyPointProductDiscounts = hasLoyaltyPointProductDiscounts;
const isRefundPayment = (loyaltyData) => {
    return !(0, lodash_1.isNil)(loyaltyData) && ((loyaltyData === null || loyaltyData === void 0 ? void 0 : loyaltyData.loyaltyReversed) || 0) < 0;
};
exports.isRefundPayment = isRefundPayment;
//# sourceMappingURL=loyaltyDiscountUtils.js.map